// Shared look for react-data-table-component instances, matching the blue
// header / white bold text / zebra rows / #ccc borders convention already
// applied globally to material-react-table pages via tableEnhancements.css
// (that CSS only targets MRT/DataGrid markup, so DataTable pages need this
// passed in explicitly via the `customStyles` prop — pair with `striped`).
export const dataTableCustomStyles = {
  tableWrapper: {
    style: {
      border: "1px solid #e0e0e0",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
      backgroundColor: "#fff",
    },
  },
  table: {
    style: {
      borderCollapse: "collapse",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#0c54a0",
      minHeight: "42px",
      borderBottom: "1px solid #bdbdbd",
    },
  },
  headCells: {
    style: {
      color: "#fff",
      fontWeight: "bold",
      fontSize: "12.5px",
      fontWeight: 600,
      padding: "10px 12px",
    },
  },
  rows: {
    style: {
      minHeight: "56px",
      borderBottom: "1px solid #e9edf2",
      fontSize: "13px",
      color: "#1f2937",
    },
    stripedStyle: {
      backgroundColor: "#ffffff",
    },
    highlightOnHoverStyle: {
      backgroundColor: "#f3f8fe",
      outline: "none",
      borderBottomColor: "#e9edf2",
    },
  },
  cells: {
    style: {
      padding: "6px 12px",
    },
  },
  pagination: {
    style: {
      borderTop: "1px solid #e9edf2",
    },
  },
};

// A "#" serial-number column, accounting for the current page/rowsPerPage
// offset so numbering continues correctly across pages instead of
// restarting at 1 on every page.
export const serialNumberColumn = (currentPage, rowsPerPage) => ({
  name: "#",
  width: "70px",
  cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
});
